import React from 'react'

export default function EmptyProductListItem() {
  return (
    <div className="product-item">
      <a className="product-item-link">
        <div className="product-item-image-container">
          <div className="product-item-placeholder">
            <span className="product-item-placeholder-icon" />
          </div>
        </div>
        <div className="product-item-placeholder-text" />
      </a>
    </div>
  )
}
